module.exports = __webpack_public_path__ + "static/media/marca-blanco.ad614c1b.png";